import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { BiRadioCircle } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { editEdafaceListing } from "../../Actions/axios";
import { toast } from "react-toastify";
import { isEmpty } from "../../Actions/common";
import SunEditor from "suneditor-react";


const Cointokenedit = () => {

  const navigate = useNavigate();
  const location = useLocation();
  let records = location.state;
  console.log("locationsss", records)
  const [questionType, setQuestionType] = useState("");

  const [filterRows, setFilterRows] = useState([{ filters: "" }]);
  const [additemsubtitle, setAdditemsubtitle] = useState(false);
  const [addinstructions, setAddinstructions] = useState(false)
  const [subtitleHeading, setSubtitleHeading] = useState("");


  const [pageName, setPageName] = useState("");
  const [inputs, setInputs] = useState([
    {
      "subheading": "",
      "instruction": "",
      "addinstructions": false,
      "subinputs": [
        {
          type: "",
          required: false,
          additem: false,
          name: "",
          content: [],
          options: []
        }
      ]
    }
  ]);

  useEffect(() => {
    if (records) {
      setInputs(records.inputs)
      setPageName(records.stepName)
      setAdditemsubtitle(records.additemsubtitle)
      setSubtitleHeading(records.subtitleHeading)
    }
  }, [records])
  console.log("ggggggggggggggggggggg", inputs, pageName)
  const addQuestion = () => {
    setInputs([
      ...inputs,
      {
        type: "",
        required: false,
        additem: false,
        addinstructions: false,
        otpcheck: false,
        otptype: "",
        name: "",
        content: [],
        options: [],
        instruction: "",
        addinstructions: false
      }
    ]);
  };

  const addFilters = (parentIndex) => {
    const newInputs = [...inputs];
    newInputs[parentIndex].subinputs.push({
      type: "",
      required: false,
      additem: false,
      name: "",
      content: [],
      options: [],
    });
    setInputs(newInputs);
  };

  const removeQuestion = (index) => {
    const list = [...inputs];
    list.splice(index, 1);
    setInputs(list);
  };
  /* 
    const handleChange = (e, index) => {
      const { id, value, checked, type } = e.target;
  console.log("rgfergefrtg",value);
  
      setInputs((prev) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          [id]: type === "checkbox" ? checked : (value == "Dropdown" || value == "Dropdown" || value == "Dropdown") ? updated.options =[] : updated
        };
        return updated;
      });
    }; */
  // const handleChange = (e, index) => {
  //   const { id, value, checked, type } = e.target;

  //   setInputs((prev) => {
  //     const updated = [...prev];
  //     if (id === "type" && !["Dropdown", "Radio", "Checkbox"].includes(value)) {
  //       updated[index] = {
  //         ...updated[index],
  //         [id]: value,
  //         options: []
  //       };
  //     } else {
  //       updated[index] = {
  //         ...updated[index],
  //         [id]: type === "checkbox" ? checked : value
  //       };
  //     }

  //     return updated;
  //   });
  // };
  const handleChange = (e, index, subIndex = null, suneditor = "") => {

    const updatedInputs = [...inputs];
    if (suneditor == "suneditor") {
      updatedInputs[index]["instruction"] = e;
    }
    else if (suneditor == "mail") {
      updatedInputs[index]["otptype"] = suneditor;
    }
    else if (suneditor == "mobile") {
      updatedInputs[index]["otptype"] = suneditor;
    }
    else {
      const { id, value, checked, type } = e?.target;
      console.log("bbbbbbbbb", id, value, checked, type)
      if (subIndex !== null) {
        updatedInputs[index].subinputs[subIndex][id] = type === "checkbox" ? checked : value;
      } else {
        updatedInputs[index][id] = type === "checkbox" ? checked : value;

        if (id === "type" && value === "MultiQuestion") {
          updatedInputs[index].subheading = "";
          updatedInputs[index].addinstructions = false;
          updatedInputs[index].instruction = "";
          updatedInputs[index].subinputs = [];
        }
      }
    }

    console.log("updatedInputs", updatedInputs)
    setInputs(updatedInputs);
  };
  const addOption = (inputIndex) => {
    console.log("valuevalue", inputIndex);
    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options.push("");
      updated[inputIndex].options = options;
      return updated;
    });
  };
  const removeOption = (inputIndex, optionIndex) => {
    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options.splice(optionIndex, 1);
      updated[inputIndex].options = options;
      return updated;
    });
  };
  const handleOptionChange = (e, inputIndex, optionIndex) => {
    const { value } = e.target;
 
    setInputs((prev) => {
      const updated = [...prev];
      const options = [...(updated[inputIndex]?.options || [])];
      options[optionIndex] = value;
      updated[inputIndex].options = options;
      return updated;
    });
  };

  const removeSubInput = (parentIndex, subIndex) => {
    const updatedInputs = [...inputs];
    updatedInputs[parentIndex]?.subinputs?.splice(subIndex, 1);
    setInputs(updatedInputs);
  };

  const handleSubmit = async () => {
    let validation = inputs?.some((el) => el?.type !== "MultiQuestion" ? (el?.type === "" || el?.name === "" || !el?.name) : false);
    console.log("TypeInputeesss",inputs)
    const subheadingcheck = inputs?.some((val)=>val?.type =="MultiQuestion" && val?.subheading =="");
    const otpFieldCheck = inputs?.some((val) => val?.type == "Shortanswer" && val?.otpcheck ? (val.otptype == "" || !val.otptype) : false);
    let optionValidation = inputs?.some((el) =>
      Array.isArray(el?.options) &&
      el?.options?.length > 0 &&
      el?.options?.some((opt) => typeof opt === "string" && opt.trim() === "")
    );

    console.log('validationvalidation', validation);

    if (isEmpty(pageName)) {
      return toast.error("Item name is required.")
    }
    if (validation) {
      return toast.error("Type or Question is required.")
    }
    if (optionValidation) {
      return toast.error("Options is required.")
    }
    if(subheadingcheck){
      return toast.error("Main heading is required.")
    }
      if (otpFieldCheck) {
          return toast.error("OTP option is required.")
        }
    const finalData = {
      _id: records?._id,
      additemsubtitle: additemsubtitle,
      subtitleHeading: subtitleHeading ? subtitleHeading : "",
      stepName: pageName,
      inputs: inputs
    };

    console.log("Final editEdafaceListing Payload:", finalData);
    const resp = await editEdafaceListing(finalData)
    console.log("GNNNNNNNNNNNNN",resp)
    if (resp?.status) {
      setInputs(resp?.data?.data)
      navigate("/cointokenlist")
      toast.success(resp?.message)
    }
    else {
      toast.error("Oops something went wrong")
    }
    // console.log("editEdafaceListing", resp)
    // API call here
  };

  return (
    <div className="cmsadd">
      <button className="btn sitebtn mb-4" onClick={() => navigate(-1)}>
        Back
      </button>

      <h1 className="pagehead">Questions</h1>

      <div className="mb-3">
        <label class="form-label">Item Name :</label>
        <input type="text" className="form-control" value={pageName} placeholder="Item Name" onChange={(e) => { setPageName(e.target.value) }} />
      </div>
      <div className="form-check mt-0 mb-2">
        <input
          className="form-check-input"
          type="checkbox"
          checked={additemsubtitle}
          onChange={() => setAdditemsubtitle((prev) => !prev)}

        />
        <label
          className="form-check-label"
        >
          Add Item Subtitle
        </label>
      </div>
      {additemsubtitle &&
        <div className="mb-3">
          <label className="form-label">Item Subtitle</label>
          <input
            type="text"
            className="form-control"
            placeholder="Item Subtitle"
            value={subtitleHeading}
            onChange={(e) => setSubtitleHeading(e.target.value)}
          />
        </div>}
      <div className="d-flex align-items-center justify-content-end">
        <button className="btn sitebtn mb-4" onClick={() => addQuestion()}>
          Add Question
        </button>
      </div>

      {inputs?.length > 0 && inputs?.map((el, i) => (
        <div className="cardbox mb-3">
          <Form.Select onChange={(e) => handleChange(e, i)}
            value={el?.type || ""}
            id="type"
          >
            <option value="" disabled >Choose Question Type</option>
            <option value="Shortanswer">Short Answer</option>
            <option value="MultiQuestion">MultiQuestion</option>
            <option value="Dropdown">Dropdown</option>
            <option value="Upload">Upload</option>
            <option value="Calendar">Calendar</option>
            <option value="Radio">
              <BiRadioCircle /> Radio
            </option>
            <option value="Checkbox">Checkbox</option>
            <option value="Paragraph">Paragraph</option>
          </Form.Select>



          {el?.type !== "MultiQuestion" &&
            <div className="mt-3 d-flex gap-3">
              <div>
                <p className="form-label">Required</p>
                <input
                  type="checkbox"
                  checked={el?.required}
                  id="required"
                  onChange={(e) => handleChange(e, i)}
                />
              </div>
              <div className="w-100">
                <p className="form-label">Question</p>
                <input
                  type="text"
                  className="form-control"
                  value={el?.name}
                  id="name"
                  placeholder="Question"
                  onChange={(e) => handleChange(e, i)}
                />
              </div>
            </div>}


          {

            el?.type === "MultiQuestion" && (
              <>
                <div className="mt-3 mb-3 d-flex align-items-center gap-3">
                  <div>
                    <p className="form-label mb-0">Required</p>
                    <input
                      type="checkbox"
                      checked={el?.required}
                      id="required"
                      onChange={(e) => handleChange(e, i)}
                    />
                  </div>
                  <div>
                  <p className="form-label mb-0">Main Heading: </p>
                  <input
                    type="text"
                    className="form-control"
                    value={el?.subheading}
                    id="subheading"
                    placeholder="Main Heading"
                    onChange={(e) => handleChange(e, i)}
                  />
                  </div>
                </div>

                <div className="text-end">
                  <button className="btn sitebtn mb-4" onClick={() => addFilters(i)}>Add Subquestion</button>
                </div>

                {el?.subinputs?.map((sub, j) => (
                  <div className="d-flex align-items-center gap-3 mb-3" key={j}>
                     <div>
                    <p className="form-label mb-0">Required</p>
                    <input
                      type="checkbox"
                      checked={sub?.required}
                      id="required"
                      onChange={(e) => handleChange(e, i, j)}
                    />
                  </div>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      value={sub.name}
                      onChange={(e) => handleChange(e, i, j)}
                      placeholder="Sub Question"
                    />
                    <button className="btn sitebtn" onClick={() => removeSubInput(i, j)}><MdDelete /></button>
                  </div>
                ))}
              </>
            )}




          {/* <div className="mt-3 d-flex gap-3">
            <div>
              <p class="form-label">Required</p>
              <input type="checkbox" checked={el?.required} className="mt-2" id="required"
                onChange={(e) => handleChange(e, i)} />
            </div>
            <div className="w-100">
              <p class="form-label">Question</p>
              <input type="text" class="form-control" id="name"
                placeholder="Question"
                value={el?.name}
                onChange={(e) => handleChange(e, i)} />
            </div>
          </div> */}

          {(el?.type === "Dropdown" || el?.type === "Radio" || el?.type === "Checkbox") && (
            <div className="mt-2">
              <h6>Dropdown Options</h6>
              <div className="text-end"><button className="btn sitebtn mb-2" onClick={() => addOption(i)}>Add Option</button></div>
              <div className="row">
                {el?.options?.length > 0 && (el?.options || []).map((opt, j) => {
                  console.log('oproruiroinsns', opt);

                  return (
                    <div className="col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                      <div className="d-flex align-items-center gap-3 mb-3">
                        <input type="text" class="form-control" placeholder="option"
                          id="options"
                          value={opt ?? ""}
                          onChange={(e) => handleOptionChange(e, i, j)} />
                        <div><MdDelete fontSize={25} className="cursor-pointer" onClick={() => removeOption(i, j)} /></div>
                      </div>
                    </div>
                  )
                }
                )}
              </div>
            </div>
          )}
          {(el?.type === "Shortanswer") && (
            <>
             {el.otpcheck ?
             <></>:
            <div class="form-check mt-3">
              <input
                class="form-check-input"
                type="checkbox"
                checked={el?.additem}
                // value=""
                // id="flexCheckDefault"
                id="additem"
                onChange={(e) => { handleChange(e, i) }}
              />
              <label class="form-check-label" for="flexCheckDefault">
                Add More
              </label>
            </div> }
            <div className="form-check mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={el.otpcheck}
                  onChange={(e) => { handleChange(e, i) }}
                  id="otpcheck"
                />
                <label
                  className="form-check-label"
                >
                  Send OTP
                </label>
              </div>
              {el.otpcheck ?
                <div className="d-flex gap-3 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" checked={el.otptype == "mail" ? true : false} type="radio" name={`flexRadioDefault${i}`} id="mail" onChange={(e) => { handleChange(e, i, "", "mail") }} />
                    <label class="form-check-label" for="flexRadioDefault1">
                      Mail OTP
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" checked={el.otptype == "mobile" ? true : false} type="radio" name={`flexRadioDefault${i}`} id="mobile" onChange={(e) => { handleChange(e, i, "", "mobile") }} />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Mobile OTP
                    </label>
                  </div>
                </div>
                :
                <></>
              }
            </>
            )}

            {(el?.type === "MultiQuestion") && (
            <div class="form-check mt-3">
              <input
                class="form-check-input"
                type="checkbox"
                checked={el?.additem}
                // value=""
                // id="flexCheckDefault"
                id="additem"
                onChange={(e) => { handleChange(e, i) }}
              />
              <label class="form-check-label" for="flexCheckDefault">
                Add More
              </label>
            </div>
          )}
          <div className="form-check mt-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="addinstructions"
              checked={inputs[i]?.addinstructions}
              onChange={(e) => handleChange(e, i)}
            />
            <label
              className="form-check-label"
            >
              Add Instructions
            </label>
          </div>
          {/* {inputs[i]?.addinstructions &&
            <div className="mb-3">
              <label className="form-label">Instruction</label>
              <input
                type="text"
                className="form-control"
                placeholder="Instruction"
                id="instruction"
                value={inputs[i]?.instruction}
                onChange={(e) => handleChange(e, i)}
              />
            </div>
          } */}
          {inputs[i]?.addinstructions && (
            <div className="mb-3">
              <label className="form-label">Instruction</label>
              <SunEditor
                defaultValue={inputs[i]?.instruction ?? "<p>Hello</p>"}
                onChange={(e) => handleChange(e, i, null, "suneditor")}
                height={300}
              />
            </div>
          )}
          <div className="text-end mt-2">
            <button
              className="btn btn-danger"
              onClick={() => removeQuestion(i)}
            >
              <MdDelete />
            </button>
          </div>


        </div>
      ))}

      <button className="btn sitebtn mt-4" onClick={handleSubmit}>Submit</button>
    </div>
  );
};

export default Cointokenedit;




